import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { NotificationService } from './notification.service'
import { Observable } from 'rxjs'
import { PATH } from '../app.api'
import { map } from 'rxjs/operators'
import { Region } from '../models/Region'

@Injectable()
export class RegionsService {
	constructor(
		private http: HttpClient
	) {}

		public getRegionsByCompanyId(companyId: string): Observable<Array<any>> {
		return this.http
			.get<any>(`${PATH}/regions/company/${companyId}`, { headers: this.setHeader() })
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public getRegionsFromMapByCompanyId(companyId: string): Observable<Array<Region>> {
		return this.http
			.get<any>(`${PATH}/regions/company/${companyId}`, { headers: this.setHeader() })
			.pipe(
				map(result => {
					return result.content
				})
			)
	}

	public createRegion(region: Region): Observable<string> {
		return this.http
			.post<any>(
				`${PATH}/regions`,
				region,
				{
					headers: this.setHeader()
				}
			)
			.pipe(
				map(result => {
					return result.message
				})
			)
	}

	public createManyRegion(regions: Array<Region>, companyId: string): Observable<string> {
		return this.http
			.post<any>(
				`${PATH}/regions/createMany`,
				{
					regions,
					companyId
				},
				{
					headers: this.setHeader()
				}
			)
			.pipe(
				map(result => {
					return result.message
				})
			)
	}

		public removeRegion(regioinId: number): Observable<string> {
		return this.http
			.delete<any>(
				`${PATH}/regions/${regioinId}`,
				{
					headers: this.setHeader()
				}
			).pipe(
				map(result => {
					return result.message
				})
			)
	}

		public editDemandRegion(region: Region): Observable<string> {
		return this.http
			.patch<any>(
				`${PATH}/regions`,
								region,
				{
					headers: this.setHeader()
				}
			).pipe(
				map(result => {
					return result.message
				})
			)
	}

		private setHeader(): HttpHeaders {
		return new HttpHeaders({ 'Content-Type': 'application/json' }).append( 'x-source-from', 'PAINEL')
	}

}
